module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "heading": "New Action",
      "show-text": _vm.showText,
      "button-text": "Action",
      "button-style": "success",
      "center-button": true,
      "round": _vm.round,
      "plain": _vm.plain,
      "button-icon": "fa fa-asterisk",
      "disableButton": _vm.disabled || _vm.readOnly,
      "disableSave": true
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('action-details', {
    ref: "ad",
    attrs: {
      "row-data": _vm.actionData,
      "site-data": _vm.siteData,
      "siteId": _vm.siteId,
      "editMode": true,
      "adding": true,
      "hide-panel": true,
      "table-ref": _vm.tr
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4929d69a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/GeneralAction.vue
// module id = 1542
// module chunks = 0